import loadingImage from '@assets/images/loading.png';

export const Loading = () => {
  return (
    <div className="h-svh max-w-full overflow-clip grid place-items-center bg-black fixed inset-0 pointer-events-none">
      <div className="text-center grid gap-24 grid-auto-rows-max">
        <img
          src={loadingImage}
          alt=""
          className="h-auto w-256 animate-[pulse_1.5s_ease-in-out_infinite]"
        />
        <p className="text-white text-lg">Loading...</p>
      </div>
    </div>
  );
};
